<ng-container #dynamicOutlet />
@if ($state().mode === 'default' || $state().mode === 'confirmation') {
<header class="oke-lightbox-default__child oke-lightbox-header">
  @if (isTemplateRef($titleContent())) {
  <ng-container [ngTemplateOutlet]="asTemplateRef($titleContent())" />
  } @else if ($titleContent()) {
  <h2 [innerHTML]="$titleContent()"></h2>
  }
</header>
<section class="oke-lightbox-default__child oke-lightbox-body">
  @if (isTemplateRef($bodyContent())) {
  <ng-container [ngTemplateOutlet]="asTemplateRef($bodyContent())" />
  } @else if ($bodyContent()) {
  <div [innerHTML]="$bodyContent()"></div>
  }
</section>
@if (($state().mode === 'default' && $state().isClosable) || $state().mode === 'confirmation') {
<footer class="oke-lightbox-default__child oke-lightbox-footer">
  @if ($state().mode === 'confirmation') {
  <button type="button" class="oke-lightbox-revert" (click)="dismiss('forced', false)">
    <span>{{ $negativeLabel() ?? 'Nevermind' }}</span>
  </button>
  }
  <button type="button" class="oke-lightbox-acknowledge" (click)="dismiss('forced')">
    <span>{{ $positiveLabel() ?? 'Ok' }}</span>
  </button>
</footer>
} } @if ($state().mode !== 'confirmation' && $state().isClosable) {
<button type="button" class="oke-lightbox-dismiss" (click)="dismiss()">
  <svg-icon src="/assets/svg/x--small.svg" style="display: contents" [svgStyle]='{display:"block"}'></svg-icon>
</button>
}
